module.exports = __webpack_public_path__ + "img/已结束.323a4691.png";